import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";
import { ConnectionHandler } from "relay-runtime";

const mutation = graphql`
  mutation AddSourceMutation($input: AddSourceInput!) {
    addSource(input: $input) {
      source {
        id
        name
        description
      }
      error
    }
  }
`;

export default (feedUrl, callback) => {
  const variables = {
    input: {
      feedUrl: feedUrl,
    },
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      console.log(response);
      if (response.addSource === null) {
        callback(response.addSource, response.error);
      } else {
        callback(response.addSource.source, response.addSource.error);
        // console.log(response.addSource.addSource.error);
      }
    },
    onError: (err) => console.log(err),
  });
};
